import { render } from "./PortfolioHeader.vue?vue&type=template&id=e7ed2ae6&scoped=true"
import script from "./PortfolioHeader.vue?vue&type=script&lang=js"
export * from "./PortfolioHeader.vue?vue&type=script&lang=js"

import "./PortfolioHeader.vue?vue&type=style&index=0&id=e7ed2ae6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ed2ae6"]])

export default __exports__